import { render } from "./BrowsePortfolioSearch.vue?vue&type=template&id=f8d66590&scoped=true"
import script from "./BrowsePortfolioSearch.vue?vue&type=script&lang=js"
export * from "./BrowsePortfolioSearch.vue?vue&type=script&lang=js"

import "./BrowsePortfolioSearch.vue?vue&type=style&index=0&id=f8d66590&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d66590"]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab});
